module.exports = __webpack_public_path__ + "static/image/temp/together/visual_list.ver2_0_2.jpeg?8b359a19";